import { createContext } from 'react';

import type { RollbackContextValue } from './types';

/**
 * Context for rollback preview mode.
 * Value is null when not in rollback mode or when data is loading.
 */
export const RollbackContext = createContext<RollbackContextValue | null>(null);
